module.exports = __webpack_public_path__ + "img/561a128.png";